import styled from 'styled-components';
import breakpoint from 'Styles/breakpoints';
import { fontBody } from 'Styles/fonts';

export const Container = styled.div`
  display: flex;
  background-color: var(--primary);
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;

  ${breakpoint('medium')} {
    padding: 56px;
  }
`;

export const FormWrapper = styled.div`
  display: inline-block;
  background-color: var(--primary);
  margin: 48px 17px 64px 15px;

  ${breakpoint('medium')} {
    margin: 0 0 0 0;
  }
`;

export const Socials = styled.div`
  display: inline-block;
  margin-top: 17px;
  font-size: 20px;

  ${breakpoint('medium')} {
    display: inline-block;
    margin-top: 17px;
  }

  ${breakpoint('large')} {
    display: inline-block;
    margin: 0;
  }
`;

export const TearLine = styled.div`
  background: linear-gradient(-30deg, var(--hover) 56px, transparent 0),
    linear-gradient(30deg, var(--hover) 56px, var(--primary) 0);
  background-position: left bottom;
  background-repeat: repeat-x;
  background-size: 65px 64px;
  display: block;
  bottom: 0px;
  left: 0px;
  width: 100%;
  height: 17px;
`;

export const Disclaimer = styled.p`
  ${fontBody(12)};
  color: var(--background);
  margin-top: 16px;
  margin-bottom: 16px;
  a {
    color: var(--background);
    text-decoration: underline;
  }
`;
